import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Modal, Button } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";

const PendingModal = (props) => {
  const { isShowPending, setIsShowPending, noteUserId, homeEmail, setReloadData, routeName, onProceedPending } = props;
  const [isLoading, setIsLoading] = useState(false);


  const handleCloseModal = () => {
    setIsShowPending(false)
  }

  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={isShowPending} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2">
                  <p><strong>Pending Proceed?</strong></p>
                  <p><strong>This action cannot be undone</strong>, are you sure you wish to proceed?!</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              onProceedPending()
            }}>
              Proceed
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default PendingModal